import { useQuery } from 'react-query';
import { getWeather } from 'api/api';

export const useGetWeather = ({ zipCode, show }) =>
  useQuery({
    queryKey: ['getWeather', show, zipCode],
    queryFn: () => getWeather({ location: zipCode }),
    enabled: !!zipCode && show,
  });
